import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { TranslationPackageLanguageBranch } from '@portal-core/translation-package-language-branches/models/translation-package-language-branch.model';

@CollectionStateSelectors({
  stateType: TranslationPackageLanguageBranchesState
})

@State<TranslationPackageLanguageBranchesState>({
  name: TranslationPackageLanguageBranchesState.source
})

@Service({ autoProvided: false })
export class TranslationPackageLanguageBranchesState extends CollectionStateBase {
  static override source: string = 'TranslationPackageLanguageBranches';
  getSource(): string {
    return TranslationPackageLanguageBranchesState.source;
  }
}

@Service()

export class TranslationPackageLanguageBranchesDataService extends CollectionDataServiceBase<TranslationPackageLanguageBranch> {
  protected readonly stateType = TranslationPackageLanguageBranchesState;
}
